import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/san-marcos")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in San Marcos, TX | Texas Made Shade",
      description: "Welded awnings, sail shades, patio & pergola covers and outdoor curtains for San Marcos & Hays County. Built in nearby Seguin — free quotes +1 (830) 390-9588.",
      keywords: "pergola covers San Marcos, pergola covers Texas, custom pergola covers San Marcos, aluminum pergola covers San Marcos",
      image: hero,
      socialTitle: "Custom Awnings & Shade — San Marcos, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving San Marcos and Hays County.",
    }),
    scripts: cityHeadScripts("San Marcos", "Hays County"),
  }),
  component: () => <CityHomePage city="San Marcos" region="Hays County" />,
});
